export { capitalizeString } from './stringUtils.js';
export { getWindowSize } from './windowUtils.js';
export { formatProfileType } from './profileUtils.js';
export { formatTrainingFocus } from './trainingUtils.js';
export { getConsistentAvatarColor, getAvatarColorPalette } from './colorUtils.js';
export {
    formatCalendarWeekString,
    formatDate,
    formatDate2,
    formatDate3,
    formatTime,
    formatWeekday,
    getISOWeekStart,
    getWeek,
    getWeekDateRange       // ← NEU HINZUGEFÜGT
} from './dateUtils.js';

export let BACKEND_URL;
if (process.env.NODE_ENV === 'production') {
    BACKEND_URL = `https://s-i-mon.de/api`;
} else {
    BACKEND_URL = `http://localhost:${3000}/api`;
}
